// import Loader from "../components/Loader";
// import Header from "../components/Header";
// import Sidebar from "../components/Sidebar";
// import SubHeader from "../components/SubHeader";
// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation, useNavigate } from "react-router";
// import {fetchTechnicianData,toggleTechnicianStatus,} from "../redux/actions/staffActions";
// import { curSym, pipViewDate } from "../auth/Pip";
// import PaginationDropdown from "../layout/PaginationDropdown";
// import ReactPagination from "../layout/ReactPagination";
// import StatusCol from "../components/StatusCol";
// import DeleteModal from "../components/modals/DeleteModal";
// import { pageRoutes } from "../routes/PageRoutes";
// import CustomDropdown from "../components/CustomDropdown";

// const statusOptions = [
//   { label: "All Status", value: "" },
//   { label: "Pending", value: "PENDING" },
//   { label: "In Progress", value: "IN_PROGRESS" },
//   { label: "Completed", value: "COMPLETED" },
//   { label: "Overdue", value: "OVERDUE" },
// ];

// const normalizeStatus = (value) =>
//   `${value ?? ""}`
//     .trim()
//     .toUpperCase()
//     .replace(/[\s-]+/g, "_");

// const TechnicianDetail = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [isToggle, setIsToggle] = useState(false);
//   const [status, setStatus] = useState("");
//   const techData = useLocation()?.state?.data || {};
//   const { isLoading1, technicianData } = useSelector(
//     (state) => state?.staffReducer,
//   );

//   const [currentPage, setCurrentPage] = useState(0);

//   const [usersPerPage, setUserPerPages] = useState(5);

//   const technicianStatus = Number(
//     technicianData?.status ?? techData?.status ?? 0,
//   );
//   const isTechnicianActive = technicianStatus === 1;
//   const statusButtonText = isTechnicianActive ? "Block" : "Activate";
//   const statusModalHeading = isTechnicianActive
//     ? "Block Technician"
//     : "Activate Technician";
//   const statusModalText = isTechnicianActive
//     ? "Are you sure you want to block this technician?"
//     : "Are you sure you want to activate this technician?";

//   const filteredJobHistory =
//     technicianData?.job_history?.filter((item) =>
//       status
//         ? normalizeStatus(
//             item?.status || item?.statusUI?.label || item?.status_ui?.label,
//           ) === normalizeStatus(status)
//         : true,
//     ) || [];

//   const displayUsers =
//     filteredJobHistory?.slice(
//       currentPage * usersPerPage,
//       (currentPage + 1) * usersPerPage,
//     ) || [];

//   const handlePageClick = (data) => {
//     setCurrentPage(data.selected);
//   };

//   console.log({ techData });

//   const onHandleClick = () => {
//     setIsToggle(!isToggle);
//   };

//   useEffect(() => {
//     dispatch(fetchTechnicianData(techData?.id));
//   }, []);

//   useEffect(() => {
//     setCurrentPage(0);
//   }, [status]);

//   const handleStatusToggle = () => {
//     const callback = (response) => {
//       if (response?.success) {
//         dispatch(fetchTechnicianData(techData?.id));
//       }
//     };

//     dispatch(
//       toggleTechnicianStatus({
//         payload: techData?.id,
//         callback,
//       }),
//     );
//   };

//   if (isLoading1) {
//     return <Loader />;
//   }
//   return (
//     <div className="ct_dashbaord_bg">
//       <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
//         <Sidebar path="" />
//         <div className="ct_content_right">
//           <Header onClick={onHandleClick} />

//           <div class="ct_px_23 ct_mt_30 pb-5">
//             <div class="">
//               <div className="d-flex justify-content-between gap-3 ct_mb_30 ct_flex_col_575">
//                 <SubHeader />
//                 <div className="ct_wrap_100_1">
//                   <button
//                     className={`ct_wrap_100_1 ${
//                       isTechnicianActive
//                         ? "ct_custom_block_btn"
//                         : "ct_custom_btm ct_border_radius_0"
//                     }`}
//                     data-bs-toggle="modal"
//                     data-bs-target="#technician_status_modal"
//                   >
//                     <svg
//                       className="me-2"
//                       width="22"
//                       height="22"
//                       viewBox="0 0 22 22"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         fill-rule="evenodd"
//                         clip-rule="evenodd"
//                         d="M10.9997 20.1663C16.0624 20.1663 20.1663 16.0624 20.1663 10.9997C20.1663 5.93692 16.0624 1.83301 10.9997 1.83301C5.93692 1.83301 1.83301 5.93692 1.83301 10.9997C1.83301 16.0624 5.93692 20.1663 10.9997 20.1663ZM6.50251 16.793L16.793 6.50251C17.8898 7.91341 18.4337 9.67628 18.3224 11.4599C18.2112 13.2435 17.4524 14.9251 16.1888 16.1888C14.9251 17.4524 13.2435 18.2112 11.4599 18.3224C9.67628 18.4337 7.91341 17.8898 6.50251 16.793ZM5.20634 15.4968C4.10952 14.0859 3.56565 12.3231 3.67692 10.5395C3.78818 8.75584 4.54691 7.07423 5.81057 5.81057C7.07423 4.54691 8.75584 3.78818 10.5395 3.67692C12.3231 3.56565 14.0859 4.10952 15.4968 5.20634L5.20634 15.4968Z"
//                         fill="white"
//                       />
//                     </svg>
//                     {statusButtonText}
//                   </button>
//                 </div>
//               </div>

//               {/* <Technicians /> */}
//               <>
//                 <div className="row mb-2">

//    <div class="col-xxl-6 col-xl-6 col-lg-6  mb-4">
//                     <div class="ct_white_bg ct_dash_card">
//                       <div class="">
//                         <div>
//                        <div class="d-flex justify-content-between gap-2 mb-2 align-items-center">
//                            <h6 class="mb-0 ct_fs_22 ct_text_dark mb-2">  {technicianData?.full_name || "-"}</h6>
//                            <div class="ct_custom_badge ms-auto" style={{backgroundColor: "rgb(203, 247, 255)" ,color: "rgb(35, 192, 232)"}}>

//                             <small class="ct_ff_ProximaNova_regular">   {technicianData?.role || "-"} </small></div>
//                        </div>

//                         <div class=" mb-3 mt-4 d-flex flex-wrap  gap-2 justify-content-between align-items-center">
//                             <span class="mb-0 ct_fs_16 ct_fw_400 ct_text_para d-flex align-items-center">
//                   <svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M1.96094 6.42833L7.7776 10.3067C8.5801 10.8408 8.98094 11.1083 9.41427 11.2125C9.7976 11.3042 10.1968 11.3042 10.5793 11.2125C11.0126 11.1083 11.4134 10.8408 12.2159 10.3067L18.0326 6.42833M5.96094 16.25H14.0326C15.4326 16.25 16.1326 16.25 16.6676 15.9775C17.1377 15.7377 17.5198 15.3553 17.7593 14.885C18.0326 14.35 18.0326 13.65 18.0326 12.25V7.75C18.0326 6.35 18.0326 5.65 17.7601 5.115C17.5204 4.64462 17.138 4.26218 16.6676 4.0225C16.1326 3.75 15.4326 3.75 14.0326 3.75H5.96094C4.56094 3.75 3.86094 3.75 3.32594 4.0225C2.85586 4.26232 2.47373 4.64474 2.23427 5.115C1.96094 5.65 1.96094 6.35 1.96094 7.75V12.25C1.96094 13.65 1.96094 14.35 2.23344 14.885C2.47312 15.3554 2.85555 15.7378 3.32594 15.9775C3.86094 16.25 4.56094 16.25 5.96094 16.25Z" stroke="#808C9D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </svg>

// Email:

//                                </span>
//                                <span className="ct_fs_16 ct_fw_600 ct_text_para">   {technicianData?.email || "-"}</span>

//                         </div>
//                              <div class="  d-flex flex-wrap gap-2 justify-content-between align-items-center">
//                             <span class="mb-0 ct_fs_16 ct_fw_400 ct_text_para d-flex align-items-center">
//             <svg className="me-1" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M4.64299 6.57296C4.40487 5.00171 5.51362 3.58796 7.20737 3.06921C7.5081 2.97717 7.83262 3.00332 8.11473 3.14234C8.39684 3.28137 8.61528 3.52278 8.72549 3.81734L9.26862 5.26734C9.35594 5.50058 9.3716 5.75459 9.31358 5.99679C9.25556 6.239 9.12652 6.45835 8.94299 6.62671L7.32737 8.10859C7.24754 8.18168 7.18806 8.27425 7.15475 8.37723C7.12145 8.48022 7.11546 8.59009 7.13737 8.69609L7.15174 8.76109L7.19174 8.92421C7.22737 9.06171 7.28112 9.25546 7.35674 9.48671C7.50674 9.94609 7.74612 10.5636 8.10237 11.1805C8.45862 11.7973 8.87362 12.3136 9.19612 12.673C9.36422 12.8599 9.53978 13.0401 9.72237 13.213L9.77237 13.2592C9.85318 13.3308 9.95115 13.3802 10.0567 13.4027C10.1623 13.4251 10.2719 13.4198 10.3749 13.3873L12.4661 12.7292C12.7037 12.6545 12.9582 12.6525 13.197 12.7235C13.4357 12.7944 13.6478 12.935 13.8061 13.1273L14.7955 14.3286C15.208 14.8286 15.1592 15.5636 14.6849 16.0055C13.3886 17.2136 11.6061 17.4617 10.3661 16.4642C8.84657 15.238 7.56529 13.7429 6.58612 12.0536C5.59975 10.3648 4.94054 8.50591 4.64299 6.57296ZM8.44674 8.77796L9.78799 7.54796C10.155 7.21123 10.4131 6.77253 10.5292 6.28813C10.6452 5.80372 10.6139 5.2957 10.4392 4.82921L9.89549 3.37921C9.67366 2.78679 9.23425 2.30127 8.66683 2.02163C8.0994 1.74198 7.44669 1.68926 6.84174 1.87421C4.73862 2.51859 3.04987 4.40421 3.40737 6.75984C3.72828 8.84852 4.44009 10.858 5.50549 12.683C6.56162 14.5047 7.94352 16.1169 9.58237 17.4392C11.4417 18.933 13.9255 18.4236 15.5374 16.9205C15.9988 16.4907 16.2789 15.9011 16.3204 15.2719C16.3618 14.6427 16.1616 14.0214 15.7605 13.5348L14.7711 12.3336C14.4545 11.9488 14.0302 11.6675 13.5525 11.5256C13.0749 11.3837 12.5658 11.3878 12.0905 11.5373L10.3549 12.0836C10.2772 12.0037 10.2011 11.9222 10.1267 11.8392C9.76992 11.4447 9.45432 11.0147 9.18487 10.5561C8.92225 10.0933 8.7076 9.60497 8.54424 9.09859C8.50955 8.9926 8.47704 8.88591 8.44674 8.77859" fill="#808C9D"/>
// </svg>

// Contact No.:

//                                </span>
//                                <span className="ct_fs_16 ct_fw_600 ct_text_para">{technicianData?.phone_no || "-"}{" "}</span>

//                         </div>
//                         </div>

//                       </div>

//                     </div>
//                   </div>

//                   <div className="col-xxl-6 col-xl-6 col-lg-6  mb-4">
//                     <div className="ct_white_bg ct_dash_card active align-items-center">
//                       <div className="d-grid gap-4">
//                         <div className="d-flex align-items-center gap-3 justify-content-between">
//                           <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
//                             Total Tasks
//                           </h6>
//                           <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
//                             {technicianData?.summary?.total_tasks || 0}
//                           </h6>
//                         </div>
//                         <div className="d-flex align-items-center gap-3 justify-content-between">
//                           <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
//                             Completion Rate
//                           </h6>
//                           <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
//                             {technicianData?.summary?.completion_rate || 0}%
//                           </h6>
//                         </div>
//                         <div className="d-flex align-items-center gap-3 justify-content-between">
//                           <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
//                             Hourly Rate
//                           </h6>
//                           <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
//                             {curSym}
//                             {technicianData?.hourly_rate || 0}
//                           </h6>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 {/*  */}
//                 <div className="row mb-2">
//                   <div className="col-xxl-4 col-xl-4 col-lg-4 col-sm-6 mb-4">
//                     <div className="ct_white_bg ct_dash_card active">
//                       <div className="d-flex align-items-center gap-3 justify-content-between">
//                         <div>
//                           <p className="mb-0">Total Jobs</p>
//                           <h3 className="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
//                             {technicianData?.summary?.total_tasks || 0}
//                           </h3>
//                         </div>
//                         <div className="ct_dash_icon">
//                           <svg
//                             width={30}
//                             height={30}
//                             viewBox="0 0 30 30"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               d="M13.7588 26.25H12.0063C7.525 26.25 5.285 26.25 3.8925 24.8313C2.5 23.4125 2.5 21.1288 2.5 16.5625C2.5 11.9963 2.5 9.7125 3.8925 8.29375C5.285 6.875 7.525 6.875 12.0063 6.875H16.76C21.2413 6.875 23.4825 6.875 24.875 8.29375C25.9463 9.385 26.1925 10.9888 26.25 13.75"
//                               stroke="white"
//                               strokeWidth="1.8"
//                               strokeLinecap="round"
//                             />
//                             <path
//                               d="M20 6.875L19.875 6.4875C19.2563 4.5625 18.9475 3.6 18.2113 3.05C17.4738 2.5 16.4963 2.5 14.5375 2.5H14.2088C12.2525 2.5 11.2738 2.5 10.5375 3.05C9.8 3.6 9.49125 4.5625 8.8725 6.4875L8.75 6.875M21.3888 16.5688C21.62 16.3563 21.735 16.25 21.875 16.25C22.015 16.25 22.13 16.3563 22.3613 16.5688L23.2525 17.39C23.36 17.4887 23.4138 17.5388 23.48 17.5625C23.5475 17.5875 23.62 17.585 23.7675 17.5787L24.97 17.5312C25.28 17.5187 25.435 17.5137 25.5413 17.6025C25.6475 17.6912 25.6688 17.845 25.71 18.1525L25.875 19.385C25.895 19.5275 25.9038 19.5975 25.9388 19.66C25.9738 19.72 26.03 19.7637 26.1425 19.8525L27.1125 20.615C27.3525 20.805 27.4725 20.8987 27.4963 21.0337C27.52 21.1687 27.4388 21.2987 27.2788 21.5587L26.6213 22.6175C26.5463 22.7387 26.5088 22.8 26.4963 22.8675C26.4838 22.935 26.4988 23.0063 26.5288 23.1463L26.79 24.3688C26.8525 24.6688 26.885 24.8188 26.8163 24.9388C26.7475 25.0588 26.6013 25.1062 26.31 25.2012L25.1525 25.5775C25.015 25.6225 24.945 25.645 24.8913 25.69C24.8375 25.7363 24.8038 25.8012 24.7375 25.93L24.1725 27.0187C24.0288 27.2975 23.9563 27.4362 23.825 27.4837C23.6938 27.5312 23.55 27.4713 23.26 27.3513L22.15 26.8913C22.0138 26.835 21.9463 26.8062 21.875 26.8062C21.8038 26.8062 21.7363 26.835 21.6 26.8913L20.49 27.3513C20.2 27.4713 20.0563 27.5312 19.925 27.4837C19.7938 27.4362 19.7213 27.2962 19.5775 27.0187L19.0125 25.93C18.945 25.8012 18.9125 25.7362 18.8588 25.6912C18.805 25.6462 18.735 25.6225 18.5975 25.5787L17.44 25.2012C17.1488 25.1062 17.0025 25.0588 16.9338 24.9388C16.865 24.8188 16.8963 24.67 16.96 24.3688L17.2225 23.1463C17.2513 23.0063 17.2663 22.9363 17.2538 22.8688C17.2281 22.7783 17.1857 22.6935 17.1288 22.6187L16.4725 21.5587C16.31 21.2987 16.23 21.1687 16.2538 21.0337C16.2775 20.8987 16.3975 20.805 16.6375 20.6163L17.6075 19.8538C17.72 19.7638 17.7763 19.72 17.8113 19.6588C17.8463 19.5975 17.855 19.5275 17.8738 19.3837L18.04 18.1525C18.0813 17.8463 18.1025 17.6912 18.2088 17.6025C18.315 17.5137 18.47 17.5187 18.78 17.5312L19.9838 17.5787C20.13 17.585 20.2025 17.5875 20.27 17.5625C20.3363 17.5375 20.39 17.4887 20.4975 17.39L21.3888 16.5688Z"
//                               stroke="white"
//                               strokeWidth="1.8"
//                             />
//                           </svg>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-xxl-4 col-xl-4 col-lg-4 col-sm-6 mb-4">
//                     <div className="ct_white_bg ct_dash_card">
//                       <div className="d-flex align-items-center gap-3 justify-content-between">
//                         <div>
//                           <p className="mb-0">In Progress Jobs</p>
//                           <h3 className="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
//                             {technicianData?.summary?.in_progress_tasks || 0}
//                           </h3>
//                         </div>
//                         <div className="ct_dash_icon">
//                           <svg
//                             width={36}
//                             height={36}
//                             viewBox="0 0 36 36"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path
//                               d="M19.5 16.5L27 9"
//                               stroke="#23C0E8"
//                               strokeWidth="1.5"
//                             />
//                             <path
//                               d="M28.4999 10.5003L25.4999 7.50031L29.2499 5.25031L30.7499 6.75031L28.4999 10.5003ZM6.03739 13.4628C5.31722 12.7433 4.82178 11.8299 4.61139 10.8339C4.401 9.83783 4.48473 8.80211 4.85238 7.85281L6.98539 9.98581H9.98539V6.98581L7.85239 4.85281C8.80176 4.48432 9.8378 4.3999 10.8343 4.60983C11.8308 4.81977 12.7447 5.31499 13.4648 6.03517C14.1848 6.75535 14.6798 7.66939 14.8895 8.66594C15.0992 9.66249 15.0146 10.6985 14.6459 11.6478L24.3509 21.3543C25.3002 20.9856 26.3362 20.901 27.3328 21.1107C28.3293 21.3204 29.2433 21.8154 29.9635 22.5354C30.6837 23.2555 31.1789 24.1694 31.3889 25.1659C31.5988 26.1624 31.5144 27.1984 31.1459 28.1478L29.0144 26.0148H26.0144V29.0148L28.1474 31.1478C27.1983 31.5163 26.1625 31.6008 25.1661 31.3912C24.1698 31.1815 23.2559 30.6866 22.5358 29.9668C21.8157 29.247 21.3205 28.3334 21.1104 27.3372C20.9002 26.3409 20.9843 25.3051 21.3524 24.3558L11.6444 14.6478C10.6955 15.0148 9.66036 15.0982 8.66493 14.8878C7.6695 14.6775 6.75665 14.1824 6.03739 13.4628Z"
//                               stroke="#23C0E8"
//                               strokeWidth="1.5"
//                               strokeLinejoin="round"
//                             />
//                             <path
//                               d="M18.304 21.7498L9.89799 30.1558C9.7099 30.3443 9.4865 30.4938 9.24056 30.5958C8.99463 30.6978 8.73099 30.7503 8.46474 30.7503C8.19849 30.7503 7.93486 30.6978 7.68892 30.5958C7.44299 30.4938 7.21958 30.3443 7.03149 30.1558L5.84349 28.9678C5.65505 28.7797 5.50554 28.5563 5.40354 28.3104C5.30153 28.0644 5.24902 27.8008 5.24902 27.5346C5.24902 27.2683 5.30153 27.0047 5.40354 26.7587C5.50554 26.5128 5.65505 26.2894 5.84349 26.1013L14.2495 17.6953"
//                               stroke="#23C0E8"
//                               strokeWidth="1.5"
//                               strokeLinejoin="round"
//                             />
//                           </svg>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-xxl-4 col-xl-4 col-lg-4 col-sm-6 mb-4">
//                     <div className="ct_white_bg ct_dash_card">
//                       <div className="d-flex align-items-center gap-3 justify-content-between">
//                         <div>
//                           <p className="mb-0">Completed Jobs</p>
//                           <h3 className="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
//                             {technicianData?.summary?.completed_tasks || 0}
//                           </h3>
//                         </div>
//                         <div className="ct_dash_icon">
//                           <svg
//                             width={36}
//                             height={36}
//                             viewBox="0 0 36 36"
//                             fill="none"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <g clipPath="url(#clip0_287_4488)">
//                               <path
//                                 d="M26.209 10.459L27.791 12.041L14.625 25.207L8.20898 18.791L9.79102 17.209L14.625 22.043L26.209 10.459ZM18 0C19.6523 0 21.2461 0.210938 22.7812 0.632812C24.3164 1.05469 25.752 1.6582 27.0879 2.44336C28.4238 3.22852 29.6367 4.16602 30.7266 5.25586C31.8164 6.3457 32.7539 7.56445 33.5391 8.91211C34.3242 10.2598 34.9277 11.6953 35.3496 13.2188C35.7715 14.7422 35.9883 16.3359 36 18C36 19.6523 35.7891 21.2461 35.3672 22.7812C34.9453 24.3164 34.3418 25.752 33.5566 27.0879C32.7715 28.4238 31.834 29.6367 30.7441 30.7266C29.6543 31.8164 28.4355 32.7539 27.0879 33.5391C25.7402 34.3242 24.3047 34.9277 22.7812 35.3496C21.2578 35.7715 19.6641 35.9883 18 36C16.3477 36 14.7539 35.7891 13.2188 35.3672C11.6836 34.9453 10.248 34.3418 8.91211 33.5566C7.57617 32.7715 6.36328 31.834 5.27344 30.7441C4.18359 29.6543 3.24609 28.4355 2.46094 27.0879C1.67578 25.7402 1.07227 24.3105 0.650391 22.7988C0.228516 21.2871 0.0117188 19.6875 0 18C0 16.3477 0.210938 14.7539 0.632812 13.2188C1.05469 11.6836 1.6582 10.248 2.44336 8.91211C3.22852 7.57617 4.16602 6.36328 5.25586 5.27344C6.3457 4.18359 7.56445 3.24609 8.91211 2.46094C10.2598 1.67578 11.6895 1.07227 13.2012 0.650391C14.7129 0.228516 16.3125 0.0117188 18 0ZM18 33.75C19.4414 33.75 20.8301 33.5625 22.166 33.1875C23.502 32.8125 24.7559 32.2852 25.9277 31.6055C27.0996 30.9258 28.166 30.0996 29.127 29.127C30.0879 28.1543 30.9082 27.0938 31.5879 25.9453C32.2676 24.7969 32.8008 23.543 33.1875 22.1836C33.5742 20.8242 33.7617 19.4297 33.75 18C33.75 16.5586 33.5625 15.1699 33.1875 13.834C32.8125 12.498 32.2852 11.2441 31.6055 10.0723C30.9258 8.90039 30.0996 7.83398 29.127 6.87305C28.1543 5.91211 27.0938 5.0918 25.9453 4.41211C24.7969 3.73242 23.543 3.19922 22.1836 2.8125C20.8242 2.42578 19.4297 2.23828 18 2.25C16.5586 2.25 15.1699 2.4375 13.834 2.8125C12.498 3.1875 11.2441 3.71484 10.0723 4.39453C8.90039 5.07422 7.83398 5.90039 6.87305 6.87305C5.91211 7.8457 5.0918 8.90625 4.41211 10.0547C3.73242 11.2031 3.19922 12.457 2.8125 13.8164C2.42578 15.1758 2.23828 16.5703 2.25 18C2.25 19.4414 2.4375 20.8301 2.8125 22.166C3.1875 23.502 3.71484 24.7559 4.39453 25.9277C5.07422 27.0996 5.90039 28.166 6.87305 29.127C7.8457 30.0879 8.90625 30.9082 10.0547 31.5879C11.2031 32.2676 12.457 32.8008 13.8164 33.1875C15.1758 33.5742 16.5703 33.7617 18 33.75Z"
//                                 fill="#23C0E8"
//                               />
//                             </g>
//                             <defs>
//                               <clipPath id="clip0_287_4488">
//                                 <rect width={36} height={36} fill="white" />
//                               </clipPath>
//                             </defs>
//                           </svg>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* table */}
//                 <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap ct_mt_25">
//                   <h3 className="ct_fs_22 ct_fw_600 mb-0 ct_ff_ProximaNova_semibold">
//                     Job History
//                   </h3>
//                   <div style={{ minWidth: "220px" }}>
//                     <CustomDropdown
//                       options={statusOptions}
//                       selectedValue={status}
//                       onChange={(value) => setStatus(value)}
//                       placeholder="Select Status"
//                     />
//                   </div>
//                 </div>
//                 <div className="ct_white_bg p-4 ct_border_radius_12 ct_mt_25">
//                   <div className="custom_table_wrapper mt-3">
//                     <div className="table-responsive  ct_custom_table">
//                       <table className="table">
//                         <thead>
//                           <tr>
//                             <th>S.NO</th>
//                             <th>JOB NAME</th>
//                             <th>BOAT REG.</th>
//                             <th>DATE SCHEDULED</th>
//                             <th>STATUS</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                             <tbody>
//                         {displayUsers?.length != 0 ? (
//                           displayUsers?.map((item, i) => (
//                               <tr>
//                                 <td className="ct_text_para">{i+1}</td>
//                                 <td className="ct_text_para">
//                                   <div className="ct_overlay_text">
//                                     {item?.job_name || "-"}
//                                   </div>
//                                 </td>
//                                 <td className="ct_text_para">{item?.boat_rego || "-"}</td>
//                                 <td className="ct_text_para">
//                                  {pipViewDate(item?.date_scheduled_from) || "-"} - {pipViewDate(item?.date_scheduled_to) || "-"}
//                                 </td>
//                                   <StatusCol
//                                 status={item?.status}
//                                 type={"jobHis"}
//                               />
//                                 <td>
//                                   <a
//                                     href="javascript:void(0)"
//                                     onClick={() => {
//                                       const jobRowId =
//                                         item?.taskId ||
//                                         item?.task_id ||
//                                         item?.id ||
//                                         item?.jobId;

//                                       if (!jobRowId) return;

//                                       navigate(pageRoutes.JobDetail, {
//                                         state: {
//                                           data: {
//                                             ...item,
//                                             taskId: jobRowId,
//                                           },
//                                         },
//                                       });
//                                     }}
//                                   >
//                                     <svg
//                                       width="22"
//                                       height="15"
//                                       viewBox="0 0 22 15"
//                                       fill="none"
//                                       xmlns="http://www.w3.org/2000/svg"
//                                     >
//                                       <path
//                                         d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
//                                         stroke="#23C0E8"
//                                         stroke-width="1.57885"
//                                         stroke-linejoin="round"
//                                       />
//                                       <path
//                                         d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
//                                         stroke="#23C0E8"
//                                         stroke-width="1.57885"
//                                         stroke-linejoin="round"
//                                       />
//                                     </svg>
//                                   </a>
//                                 </td>
//                               </tr>
//                                 ))
//                         ) : (
//                           <tr>
//                             <td colSpan={6}>
//                                <h3 className="mt-3 mb-0 ct_fs_18 text-center">
//                               No job history found
//                             </h3>
//                             </td>
//                           </tr>
//                           // <div className="col-xl-12 col-lg-12 text-center">

//                           // </div>
//                         )}
//                               {/* <tr>
//                                 <td className="ct_text_para">2</td>
//                                 <td className="ct_text_para">
//                                   <div className="ct_overlay_text">
//                                     Hull Integrity Survey
//                                   </div>
//                                 </td>
//                                 <td className="ct_text_para">Sea Voyager</td>
//                                 <td className="ct_text_para">
//                                   10/09/2025 - 25/09/2025
//                                 </td>
//                                 <td>
//                                   <div className="d-flex align-items-center gap-3">
//                                     <span className="active-dot" />
//                                     <span className="ct_active_badge">
//                                       Completed
//                                     </span>
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <a href="#">
//                                     <svg
//                                       width="22"
//                                       height="15"
//                                       viewBox="0 0 22 15"
//                                       fill="none"
//                                       xmlns="http://www.w3.org/2000/svg"
//                                     >
//                                       <path
//                                         d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
//                                         stroke="#23C0E8"
//                                         stroke-width="1.57885"
//                                         stroke-linejoin="round"
//                                       />
//                                       <path
//                                         d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
//                                         stroke="#23C0E8"
//                                         stroke-width="1.57885"
//                                         stroke-linejoin="round"
//                                       />
//                                     </svg>
//                                   </a>
//                                 </td>
//                               </tr>
//                               <tr>
//                                 <td className="ct_text_para">3</td>
//                                 <td className="ct_text_para">
//                                   <div className="ct_overlay_text">
//                                     Hull Integrity Survey
//                                   </div>
//                                 </td>
//                                 <td className="ct_text_para">Sea Voyager</td>
//                                 <td className="ct_text_para">
//                                   10/09/2025 - 25/09/2025
//                                 </td>
//                                 <td>
//                                   <div className="d-flex align-items-center gap-3">
//                                     <span className="active-dot" />
//                                     <span className="ct_active_badge">
//                                       Completed
//                                     </span>
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <a href="#">
//                                     <svg
//                                       width="22"
//                                       height="15"
//                                       viewBox="0 0 22 15"
//                                       fill="none"
//                                       xmlns="http://www.w3.org/2000/svg"
//                                     >
//                                       <path
//                                         d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
//                                         stroke="#23C0E8"
//                                         stroke-width="1.57885"
//                                         stroke-linejoin="round"
//                                       />
//                                       <path
//                                         d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
//                                         stroke="#23C0E8"
//                                         stroke-width="1.57885"
//                                         stroke-linejoin="round"
//                                       />
//                                     </svg>
//                                   </a>
//                                 </td>
//                               </tr> */}
//                             </tbody>

//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </>

//               <div className="mt-3">
//                 {filteredJobHistory?.length >= 5 &&
//                   filteredJobHistory?.length > 0 && (
//                     <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-3">
//                       <PaginationDropdown
//                         onChange={(val) => {
//                           setUserPerPages(val);
//                           setCurrentPage(0);
//                         }}
//                       />
//                       <ReactPagination
//                         pageCount={Math.ceil(
//                           filteredJobHistory?.length / usersPerPage,
//                         )}
//                         onPageChange={handlePageClick}
//                         currentPage={currentPage}
//                       />
//                     </div>
//                   )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <DeleteModal
//         modalId="technician_status_modal"
//         heading={statusModalHeading}
//         value={statusModalText}
//         confirmText={statusButtonText}
//         handleDelete={handleStatusToggle}
//       />
//     </div>
//   );
// };

// export default TechnicianDetail;

import Loader from "../components/Loader";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import SubHeader from "../components/SubHeader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  fetchTechnicianData,
  toggleTechnicianStatus,
} from "../redux/actions/staffActions";
import { curSym, pipViewDate } from "../auth/Pip";
import PaginationDropdown from "../layout/PaginationDropdown";
import ReactPagination from "../layout/ReactPagination";
import StatusCol from "../components/StatusCol";
import DeleteModal from "../components/modals/DeleteModal";
import { pageRoutes } from "../routes/PageRoutes";
import CustomDropdown from "../components/CustomDropdown";

const normalizeStatus = (value) =>
  `${value ?? ""}`
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");

const getActivityStatus = (item = {}) =>
  [
    item?.status,
    item?.boat_status,
    item?.task_status,
    item?.job_status,
    item?.activity_status,
    item?.punctuality_status,
    item?.performance_status,
    item?.statusUI?.label,
    item?.status_ui?.label,
  ]
    .map((value) => normalizeStatus(value))
    .find(Boolean) || "";

const formatStatusLabel = (value) => {
  const normalizedValue = normalizeStatus(value);

  if (!normalizedValue) {
    return "-";
  }

  return normalizedValue
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(" ");
};

const defaultBoatStatusOptions = ["ASSIGNED", "UNASSIGNED"];

const buildStatusOptions = (items = []) => [
  { label: "All Status", value: "" },
  ...Array.from(
    new Set(items.map((item) => getActivityStatus(item)).filter(Boolean)),
  ).map((status) => ({
    label: formatStatusLabel(status),
    value: status,
  })),
];

const useCountUp = (target, duration = 900) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    let start = null;
    const num = parseFloat(target) || 0;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      setVal(Math.floor(ease * num));
      if (progress < 1) requestAnimationFrame(step);
      else setVal(num);
    };
    requestAnimationFrame(step);
  }, [target]);
  return val;
};

const AnimBar = ({ pct, color, bg, delay = 0 }) => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setWidth(pct), 150 + delay);
    return () => clearTimeout(t);
  }, [pct]);
  return (
    <div
      style={{
        height: 10,
        borderRadius: 8,
        background: bg,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${width}%`,
          background: color,
          borderRadius: 8,
          transition: "width 0.8s cubic-bezier(0.4,0,0.2,1)",
          minWidth: pct > 0 ? 6 : 0,
        }}
      />
    </div>
  );
};

const DonutRing = ({
  segments,
  total,
  completionRate,
  size = 160,
  thickness = 20,
}) => {
  const r = (size - thickness) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circ = 2 * Math.PI * r;
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setAnimated(true), 100);
    return () => clearTimeout(t);
  }, []);

  let offset = -0.25;
  const slices = segments.map((seg) => {
    const pct = total > 0 ? seg.value / total : 0;
    const dash = animated ? pct * circ : 0;
    const gap = circ - dash;
    const dashOffset = -offset * circ;
    offset += pct;
    return { ...seg, dash, gap, dashOffset };
  });

  const animVal = useCountUp(completionRate);

  return (
    <div style={{ position: "relative", width: size, height: size }}>
      <svg width={size} height={size}>
        <circle
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke="rgba(0,0,0,0.07)"
          strokeWidth={thickness}
        />
        {total === 0
          ? null
          : slices.map((s, i) => (
            <circle
              key={i}
              cx={cx}
              cy={cy}
              r={r}
              fill="none"
              stroke={s.color}
              strokeWidth={thickness}
              strokeDasharray={`${s.dash} ${s.gap}`}
              strokeDashoffset={s.dashOffset}
              style={{
                transition: "stroke-dasharray 1s cubic-bezier(0.4,0,0.2,1)",
                transformOrigin: `${cx}px ${cy}px`,
              }}
            />
          ))}
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          textAlign: "center",
          lineHeight: 1.2,
        }}
      >
        <div style={{ fontSize: 22, fontWeight: 800, color: "#013760" }}>
          {animVal}%
        </div>
        <div
          style={{ fontSize: 11, color: "#888", fontWeight: 600, marginTop: 2 }}
        >
          Done
        </div>
      </div>
    </div>
  );
};

const TechnicianActivityTab = ({
  activity = {},
  summary = {},
  boatsWorkedOn = [],
}) => {
  const [boatStatus, setBoatStatus] = useState("");
  const [boatCurrentPage, setBoatCurrentPage] = useState(0);
  const [boatRowsPerPage, setBoatRowsPerPage] = useState(5);
  const performanceSummary = activity?.performance_summary || {};
  const jobsOverview = activity?.jobs_overview || {};
  const punctualityMetrics = activity?.punctuality_metrics || {};
  const efficiencyMetrics = activity?.efficiency_metrics || {};
  const productivityMetrics = activity?.productivity_metrics || {};

  const boatStatusOptions = [
    { label: "All Status", value: "" },
    ...Array.from(
      new Set([
        ...defaultBoatStatusOptions,
        ...boatsWorkedOn.map((boat) => getActivityStatus(boat)).filter(Boolean),
      ]),
    ).map((status) => ({
      label: formatStatusLabel(status),
      value: status,
    })),
  ];
  const filteredBoatsWorkedOn = boatsWorkedOn?.filter((boat) =>
    boatStatus ? getActivityStatus(boat) === boatStatus : true,
  );
  const paginatedBoatsWorkedOn =
    filteredBoatsWorkedOn?.slice(
      boatCurrentPage * boatRowsPerPage,
      (boatCurrentPage + 1) * boatRowsPerPage,
    ) || [];

  useEffect(() => {
    setBoatCurrentPage(0);
  }, [boatStatus]);

  useEffect(() => {
    const totalPages = Math.ceil(
      (filteredBoatsWorkedOn?.length || 0) / boatRowsPerPage,
    );

    if (totalPages > 0 && boatCurrentPage >= totalPages) {
      setBoatCurrentPage(totalPages - 1);
    }

    if (totalPages === 0 && boatCurrentPage !== 0) {
      setBoatCurrentPage(0);
    }
  }, [filteredBoatsWorkedOn?.length, boatRowsPerPage, boatCurrentPage]);

  const total =
    jobsOverview?.total?.count ??
    performanceSummary?.total_jobs ??
    summary?.total_tasks ??
    0;
  const completed =
    jobsOverview?.completed?.count ??
    performanceSummary?.completed_jobs ??
    summary?.completed_tasks ??
    0;
  const pending =
    jobsOverview?.pending?.count ??
    performanceSummary?.pending_jobs ??
    summary?.pending_tasks ??
    0;
  const inProgress =
    jobsOverview?.in_progress?.count ??
    performanceSummary?.in_progress_jobs ??
    summary?.in_progress_tasks ??
    0;
  const overdue =
    jobsOverview?.overdue?.count ??
    performanceSummary?.overdue_jobs ??
    summary?.overdue_tasks ??
    0;
  const compRate =
    performanceSummary?.completion_rate ??
    jobsOverview?.completed?.percentage ??
    summary?.completion_rate ??
    0;

  const animTotal = useCountUp(total);
  const animCompleted = useCountUp(completed);
  const animPending = useCountUp(pending);
  const animInProgress = useCountUp(inProgress);
  const animOverdue = useCountUp(overdue);
  const animCompRate = useCountUp(compRate);

  const perfCards = [
    {
      label: "Total Jobs",
      animVal: animTotal,
      suffix: "",
      color: "#013760",
      bg: "rgba(1,55,96,0.08)",
      icon: (
        <svg width={20} height={20} viewBox="0 0 18 20" fill="none">
          <path
            d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H6.2C6.41667 1.4 6.77917 0.916667 7.2875 0.55C7.79583 0.183333 8.36667 0 9 0C9.63333 0 10.2042 0.183333 10.7125 0.55C11.2208 0.916667 11.5833 1.4 11.8 2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V4H2V18ZM4 16H11V14H4V16ZM4 12H14V10H4V12ZM4 8H14V6H4V8Z"
            fill="#013760"
          />
        </svg>
      ),
    },
    {
      label: "Completed Jobs",
      animVal: animCompleted,
      suffix: "",
      color: "#009C35",
      bg: "rgba(0,156,53,0.08)",
      icon: (
        <svg width={22} height={21} viewBox="0 0 22 21" fill="none">
          <path
            d="M7.6 21L5.7 17.8L2.1 17L2.45 13.3L0 10.5L2.45 7.7L2.1 4L5.7 3.2L7.6 0L11 1.45L14.4 0L16.3 3.2L19.9 4L19.55 7.7L22 10.5L19.55 13.3L19.9 17L16.3 17.8L14.4 21L11 19.55L7.6 21ZM9.95 14.05L15.6 8.4L14.2 6.95L9.95 11.2L7.8 9.1L6.4 10.5L9.95 14.05Z"
            fill="#009C35"
          />
        </svg>
      ),
    },
    {
      label: "Pending Jobs",
      animVal: animPending,
      suffix: "",
      color: "#EF9F27",
      bg: "rgba(239,159,39,0.08)",
      icon: (
        <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
          <path
            d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm1-8h4v2h-6V7h2v5z"
            fill="#EF9F27"
          />
        </svg>
      ),
    },
    {
      label: "In Progress",
      animVal: animInProgress,
      suffix: "",
      color: "#596575",
      bg: "rgba(89,101,117,0.08)",
      icon: (
        <svg width={19} height={21} viewBox="0 0 19 21" fill="none">
          <path
            d="M14 21C12.6167 21 11.4375 20.5125 10.4625 19.5375C9.4875 18.5625 9 17.3833 9 16C9 14.6167 9.4875 13.4375 10.4625 12.4625C11.4375 11.4875 12.6167 11 14 11C15.3833 11 16.5625 11.4875 17.5375 12.4625C18.5125 13.4375 19 14.6167 19 16C19 17.3833 18.5125 18.5625 17.5375 19.5375C16.5625 20.5125 15.3833 21 14 21ZM15.675 18.375L16.375 17.675L14.5 15.8V13H13.5V16.2L15.675 18.375ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H6.175C6.35833 1.41667 6.71667 0.9375 7.25 0.5625C7.78333 0.1875 8.36667 0 9 0C9.66667 0 10.2625 0.1875 10.7875 0.5625C11.3125 0.9375 11.6667 1.41667 11.85 2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V10.25C17.7 10.0333 17.3833 9.85 17.05 9.7C16.7167 9.55 16.3667 9.41667 16 9.3V4H14V7H4V4H2V18H7.3C7.41667 18.3667 7.55 18.7167 7.7 19.05C7.85 19.3833 8.03333 19.7 8.25 20H2Z"
            fill="#596575"
          />
        </svg>
      ),
    },
    {
      label: "Overdue Jobs",
      animVal: animOverdue,
      suffix: "",
      color: "#CB0B03",
      bg: "rgba(203,11,3,0.08)",
      icon: (
        <svg width={23} height={23} viewBox="0 0 23 23" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.1875 1.4375C7.47344 1.4375 7.74766 1.55109 7.94985 1.75328C8.15204 1.95546 8.26562 2.22969 8.26562 2.51562V4.3125H15.4531V2.51562C15.4531 2.22969 15.5667 1.95546 15.7689 1.75328C15.9711 1.55109 16.2453 1.4375 16.5312 1.4375C16.8172 1.4375 17.0914 1.55109 17.2936 1.75328C17.4958 1.95546 17.6094 2.22969 17.6094 2.51562V4.3125H20.125C20.5062 4.3125 20.8719 4.46395 21.1415 4.73353C21.411 5.00312 21.5625 5.36875 21.5625 5.75V11.8594C21.5625 12.1453 21.4489 12.4195 21.2467 12.6217C21.0445 12.8239 20.7703 12.9375 20.4844 12.9375C20.1984 12.9375 19.9242 12.8239 19.722 12.6217C19.5198 12.4195 19.4062 12.1453 19.4062 11.8594V10.7812H3.59375V19.4062H11.8594C12.1453 19.4062 12.4195 19.5198 12.6217 19.722C12.8239 19.9242 12.9375 20.1984 12.9375 20.4844C12.9375 20.7703 12.8239 21.0445 12.6217 21.2467C12.4195 21.4489 12.1453 21.5625 11.8594 21.5625H2.875C2.49375 21.5625 2.12812 21.411 1.85853 21.1415C1.58895 20.8719 1.4375 20.5062 1.4375 20.125V5.75C1.4375 5.36875 1.58895 5.00312 1.85853 4.73353C2.12812 4.46395 2.49375 4.3125 2.875 4.3125H6.10938V2.51562C6.10938 2.22969 6.22296 1.95546 6.42515 1.75328C6.62734 1.55109 6.90156 1.4375 7.1875 1.4375ZM3.59375 8.625H19.4062V6.46875H3.59375V8.625Z"
            fill="#CB0B03"
          />
        </svg>
      ),
    },
    {
      label: "Completion Rate",
      animVal: animCompRate,
      suffix: "%",
      color: "#000",
      bg: "rgba(0,0,0,0.04)",
      icon: (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none">
          <path
            d="M19 5L5 19M17.5 20C19.167 20 20 19.143 20 17C20 14.857 19.167 14 17.5 14C15.833 14 15 14.857 15 17C15 19.143 15.833 20 17.5 20ZM6.5 10C8.167 10 9 9.143 9 7C9 4.857 8.167 4 6.5 4C4.833 4 4 4.857 4 7C4 9.143 4.833 10 6.5 10Z"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];

  const donutSegments = [
    { value: completed, color: "#009C35", label: "Completed" },
    { value: pending, color: "#EF9F27", label: "Pending" },
    { value: inProgress, color: "#596575", label: "In Progress" },
    { value: overdue, color: "#CB0B03", label: "Overdue" },
  ];

  const barData = [
    {
      label: "Total",
      value: total,
      color: "#013760",
      bg: "rgba(1,55,96,0.08)",
    },
    {
      label: "Completed",
      value: completed,
      color: "#009C35",
      bg: "rgba(0,156,53,0.08)",
    },
    {
      label: "Pending",
      value: pending,
      color: "#EF9F27",
      bg: "rgba(239,159,39,0.08)",
    },
    {
      label: "In Progress",
      value: inProgress,
      color: "#596575",
      bg: "rgba(89,101,117,0.08)",
    },
    {
      label: "Overdue",
      value: overdue,
      color: "#CB0B03",
      bg: "rgba(203,11,3,0.08)",
    },
  ];

  const punctualityRows = [
    {
      label: "Early Completed Tasks",
      value: punctualityMetrics?.early_completed_tasks ?? 0,
    },
    {
      label: "On Time Tasks",
      value: punctualityMetrics?.on_time_tasks ?? 0,
    },
    {
      label: "Late Tasks",
      value: punctualityMetrics?.late_tasks ?? 0,
    },
    {
      label: "Punctuality Score",
      value: `${punctualityMetrics?.punctuality_score ?? 0}%`,
    },
  ];

  const efficiencyRows = [
    {
      label: "Excellent Tasks",
      value: efficiencyMetrics?.excellent_tasks ?? 0,
    },
    {
      label: "Good Tasks",
      value: efficiencyMetrics?.good_tasks ?? 0,
    },
    {
      label: "Average Tasks",
      value: efficiencyMetrics?.average_tasks ?? 0,
    },
    {
      label: "Poor Tasks",
      value: efficiencyMetrics?.poor_tasks ?? 0,
    },
  ];

  const productivityRows = [
    {
      label: "Total Photos Uploaded",
      value: productivityMetrics?.total_photos_uploaded ?? 0,
    },
    {
      label: "Total Services Completed",
      value: productivityMetrics?.total_services_completed ?? 0,
    },
    {
      label: "Total Materials Used",
      value: productivityMetrics?.total_materials_used ?? 0,
    },
    {
      label: "Total Working Hours",
      value: productivityMetrics?.total_working_hours ?? 0,
    },
    {
      label: "Average Job Completion Hours",
      value: productivityMetrics?.average_job_completion_hours ?? 0,
    },
  ];

  const maxBar = Math.max(...barData.map((b) => b.value), 1);

  return (
    <div>
      <div className="ct_white_bg p-4 ct_border_radius_12 ct_mb_32">
        <h3 className="ct_fs_18 ct_fw_600 mb-4 ct_ff_ProximaNova_semibold">
          Performance Summary
        </h3>
        <div className="row">
          {perfCards.map((card, i) => (
            <div
              key={i}
              className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 mb-4"
            >
              <div
                className="ct_white_bg ct_p_24 ct_user_card_new ct_border_radius_12 h-100"
                style={{ border: `1px solid ${card.color}18` }}
              >
                <div>
                  <p className="mb-1 ct_fs_14 ct_text_para ct_ff_ProximaNova_semibold">
                    {card.label}
                  </p>
                  <h3 className="ct_fs_30 mb-0 text-dark ct_ff_ProximaNova_bold">
                    {card.animVal}
                    {card.suffix}
                  </h3>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    background: card.bg,
                    flexShrink: 0,
                  }}
                >
                  {card.icon}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="ct_white_bg p-4 ct_border_radius_12 ct_mb_32">
        <h3 className="ct_fs_18 ct_fw_600 mb-4 ct_ff_ProximaNova_semibold">
          Jobs Overview
        </h3>
        <div className="row align-items-center g-4">
          <div className="col-lg-4 col-md-5 d-flex flex-column align-items-center">
            <DonutRing
              segments={donutSegments}
              // total={total || 1}
              techdet
              total={donutSegments.reduce((sum, s) => sum + s.value, 0) || 1}

              completionRate={compRate}
              size={160}
              thickness={20}
            />
            <div className="mt-3 d-flex flex-wrap justify-content-center gap-2">
              {donutSegments.map((s, i) => (
                <div key={i} className="d-flex align-items-center gap-1">
                  <span
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: s.color,
                      display: "inline-block",
                      flexShrink: 0,
                    }}
                  />
                  <span
                    className="ct_fs_12 ct_text_para ct_ff_ProximaNova_semibold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {s.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-8 col-md-7">
            <div className="d-flex flex-column gap-3">
              {barData.map((bar, i) => (
                <div key={i}>
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="ct_fs_13 ct_fw_600 ct_text_para ct_ff_ProximaNova_semibold">
                      {bar.label}
                    </span>
                    <span
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: bar.color,
                        minWidth: 28,
                        textAlign: "right",
                      }}
                    >
                      {bar.value}
                    </span>
                  </div>
                  <AnimBar
                    pct={(bar.value / maxBar) * 100}
                    color={bar.color}
                    bg={bar.bg}
                    delay={i * 80}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-6 col-md-6 mb-4">
          <div className="ct_white_bg p-4 ct_border_radius_12 h-100">
            <h3 className="ct_fs_18 ct_fw_600 mb-3 ct_ff_ProximaNova_semibold">
              Punctuality Metrics
            </h3>
            <div className="table-responsive">
              <table className="table mb-0">
                <tbody>
                  {punctualityRows.map((row, index) => (
                    <tr key={index}>
                      <td className="ct_text_para">{row.label}</td>
                      <td className="ct_text_dark ct_fw_600 text-end">
                        {row.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* <div className="col-xl-4 col-md-6 mb-4">
          <div className="ct_white_bg p-4 ct_border_radius_12 h-100">
            <h3 className="ct_fs_18 ct_fw_600 mb-3 ct_ff_ProximaNova_semibold">
              Efficiency Metrics
            </h3>
            <div className="table-responsive">
              <table className="table mb-0">
                <tbody>
                  {efficiencyRows.map((row, index) => (
                    <tr key={index}>
                      <td className="ct_text_para">{row.label}</td>
                      <td className="ct_text_dark ct_fw_600 text-end">
                        {row.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
        <div className="col-xl-6 col-md-6 mb-4">
          <div className="ct_white_bg p-4 ct_border_radius_12 h-100">
            <h3 className="ct_fs_18 ct_fw_600 mb-3 ct_ff_ProximaNova_semibold">
              Productivity Metrics
            </h3>
            <div className="table-responsive">
              <table className="table mb-0">
                <tbody>
                  {productivityRows.map((row, index) => (
                    <tr key={index}>
                      <td className="ct_text_para">{row.label}</td>
                      <td className="ct_text_dark ct_fw_600 text-end">
                        {row.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="ct_white_bg p-4 ct_border_radius_12 ct_mb_32">
        <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
          <h3 className="ct_fs_18 ct_fw_600 mb-0 ct_ff_ProximaNova_semibold">
            Boats Worked On
          </h3>
          <div className="ct_min_w_220">
            <CustomDropdown
              options={boatStatusOptions}
              selectedValue={boatStatus}
              onChange={(value) => setBoatStatus(value)}
              placeholder="Select Status"
            />
          </div>
        </div>
        <div className="table-responsive ct_custom_table">
          <table className="table mb-0">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>BOAT NAME</th>
                <th>REGO</th>
                <th>MAKE / MODEL</th>
                <th>OWNER</th>
                <th>STATUS</th>
                <th>TOTAL TASKS</th>
                <th>COMPLETED TASKS</th>
              </tr>
            </thead>
            <tbody>
              {paginatedBoatsWorkedOn?.length ? (
                paginatedBoatsWorkedOn.map((boat, index) => (
                  <tr key={boat?.boat_id || index}>
                    <td className="ct_text_para">
                      {boatCurrentPage * boatRowsPerPage + index + 1}
                    </td>
                    <td className="ct_text_para">
                      <div className="ct_overlay_text">
                        {boat?.boat_name || "-"}
                      </div>
                    </td>
                    <td className="ct_text_para">{boat?.boat_rego || "-"}</td>
                    <td className="ct_text_para">
                      {[boat?.boat_make, boat?.boat_model]
                        .filter(Boolean)
                        .join(" / ") || "-"}
                    </td>
                    <td className="ct_text_para">{boat?.boat_owner || "-"}</td>
                    <StatusCol
                      status={getActivityStatus(boat)}
                      type={"jobHis"}
                    />
                    <td className="ct_text_para">{boat?.total_tasks ?? 0}</td>
                    <td className="ct_text_para">
                      {boat?.completed_tasks ?? 0}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>
                    <h3 className="mt-3 mb-0 ct_fs_18 text-center">
                      No boats found
                    </h3>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {filteredBoatsWorkedOn?.length && (
        <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mt-3">
          <PaginationDropdown
            onChange={(val) => {
              setBoatRowsPerPage(Number(val));
              setBoatCurrentPage(0);
            }}
          />
          <ReactPagination
            pageCount={Math.ceil(
              filteredBoatsWorkedOn.length / boatRowsPerPage,
            )}
            onPageChange={(data) => setBoatCurrentPage(data.selected)}
            currentPage={boatCurrentPage}
          />
        </div>
      )}
    </div>
  );
};

const TechnicianDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isToggle, setIsToggle] = useState(false);
  const [status, setStatus] = useState("");
  const [activeTab, setActiveTab] = useState("jobHistory"); // "jobHistory" | "activity"
  const techData = useLocation()?.state?.data || {};
  const { isLoading1, technicianData } = useSelector(
    (state) => state?.staffReducer,
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);

  const technicianStatus = Number(
    technicianData?.status ?? techData?.status ?? 0,
  );
  const isTechnicianActive = technicianStatus === 1;
  const statusButtonText = isTechnicianActive ? "Block" : "Activate";
  const statusModalHeading = isTechnicianActive
    ? "Block Technician"
    : "Activate Technician";
  const statusModalText = isTechnicianActive
    ? "Are you sure you want to block this technician?"
    : "Are you sure you want to activate this technician?";
  const technicianStatusOptions = buildStatusOptions(
    technicianData?.job_history || [],
  );

  const filteredJobHistory =
    technicianData?.job_history?.filter((item) =>
      status ? getActivityStatus(item) === status : true,
    ) || [];

  const displayUsers =
    filteredJobHistory?.slice(
      currentPage * usersPerPage,
      (currentPage + 1) * usersPerPage,
    ) || [];

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  useEffect(() => {
    dispatch(fetchTechnicianData(techData?.id));
  }, []);

  useEffect(() => {
    setCurrentPage(0);
  }, [status]);

  const handleStatusToggle = () => {
    const callback = (response) => {
      if (response?.success) {
        dispatch(fetchTechnicianData(techData?.id));
      }
    };
    dispatch(
      toggleTechnicianStatus({
        payload: techData?.id,
        callback,
      }),
    );
  };

  if (isLoading1) {
    return <Loader />;
  }

  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div className="ct_px_23 ct_mt_30 pb-5">
            <div>
              <div className="d-flex justify-content-between gap-3 ct_mb_30 ct_flex_col_575">
                <SubHeader />
                <div className="ct_wrap_100_1">
                  <button
                    className={`ct_wrap_100_1 ${isTechnicianActive
                      ? "ct_custom_block_btn"
                      : "ct_custom_activate_btn ct_border_radius_0"
                      }`}
                    data-bs-toggle="modal"
                    data-bs-target="#technician_status_modal"
                  >
                    {isTechnicianActive && (
                      <svg
                        className="me-2"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M10.9997 20.1663C16.0624 20.1663 20.1663 16.0624 20.1663 10.9997C20.1663 5.93692 16.0624 1.83301 10.9997 1.83301C5.93692 1.83301 1.83301 5.93692 1.83301 10.9997C1.83301 16.0624 5.93692 20.1663 10.9997 20.1663ZM6.50251 16.793L16.793 6.50251C17.8898 7.91341 18.4337 9.67628 18.3224 11.4599C18.2112 13.2435 17.4524 14.9251 16.1888 16.1888C14.9251 17.4524 13.2435 18.2112 11.4599 18.3224C9.67628 18.4337 7.91341 17.8898 6.50251 16.793ZM5.20634 15.4968C4.10952 14.0859 3.56565 12.3231 3.67692 10.5395C3.78818 8.75584 4.54691 7.07423 5.81057 5.81057C7.07423 4.54691 8.75584 3.78818 10.5395 3.67692C12.3231 3.56565 14.0859 4.10952 15.4968 5.20634L5.20634 15.4968Z"
                          fill="white"
                        />
                      </svg>
                    )}

                    {statusButtonText}
                  </button>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-xxl-6 col-xl-6 col-lg-6 mb-4">
                  <div className="ct_white_bg ct_dash_card">
                    <div>
                      <div className=" mb-2 ">
                        <h6 className="mb-0 ct_fs_22 ct_text_dark mb-2">
                          {technicianData?.full_name || "-"}
                        </h6>

                      </div>
                      <div className="mb-3 mt-4 d-flex flex-wrap gap-2 justify-content-between align-items-center">
                        <span className="mb-0 ct_fs_16 ct_fw_400 ct_text_para d-flex align-items-center">
                          <svg
                            className="me-1"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M1.96094 6.42833L7.7776 10.3067C8.5801 10.8408 8.98094 11.1083 9.41427 11.2125C9.7976 11.3042 10.1968 11.3042 10.5793 11.2125C11.0126 11.1083 11.4134 10.8408 12.2159 10.3067L18.0326 6.42833M5.96094 16.25H14.0326C15.4326 16.25 16.1326 16.25 16.6676 15.9775C17.1377 15.7377 17.5198 15.3553 17.7593 14.885C18.0326 14.35 18.0326 13.65 18.0326 12.25V7.75C18.0326 6.35 18.0326 5.65 17.7601 5.115C17.5204 4.64462 17.138 4.26218 16.6676 4.0225C16.1326 3.75 15.4326 3.75 14.0326 3.75H5.96094C4.56094 3.75 3.86094 3.75 3.32594 4.0225C2.85586 4.26232 2.47373 4.64474 2.23427 5.115C1.96094 5.65 1.96094 6.35 1.96094 7.75V12.25C1.96094 13.65 1.96094 14.35 2.23344 14.885C2.47312 15.3554 2.85555 15.7378 3.32594 15.9775C3.86094 16.25 4.56094 16.25 5.96094 16.25Z"
                              stroke="#808C9D"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          Email:
                        </span>
                        <span className="ct_fs_16 ct_fw_600 ct_text_para text-break">
                          {technicianData?.email || "-"}
                        </span>
                      </div>
                      <div className="mb-3 d-flex flex-wrap gap-2 justify-content-between align-items-center">
                        <span className="mb-0 ct_fs_16 ct_fw_400 ct_text_para d-flex align-items-center">
                          <svg
                            className="me-1"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M4.64299 6.57296C4.40487 5.00171 5.51362 3.58796 7.20737 3.06921C7.5081 2.97717 7.83262 3.00332 8.11473 3.14234C8.39684 3.28137 8.61528 3.52278 8.72549 3.81734L9.26862 5.26734C9.35594 5.50058 9.3716 5.75459 9.31358 5.99679C9.25556 6.239 9.12652 6.45835 8.94299 6.62671L7.32737 8.10859C7.24754 8.18168 7.18806 8.27425 7.15475 8.37723C7.12145 8.48022 7.11546 8.59009 7.13737 8.69609L7.15174 8.76109L7.19174 8.92421C7.22737 9.06171 7.28112 9.25546 7.35674 9.48671C7.50674 9.94609 7.74612 10.5636 8.10237 11.1805C8.45862 11.7973 8.87362 12.3136 9.19612 12.673C9.36422 12.8599 9.53978 13.0401 9.72237 13.213L9.77237 13.2592C9.85318 13.3308 9.95115 13.3802 10.0567 13.4027C10.1623 13.4251 10.2719 13.4198 10.3749 13.3873L12.4661 12.7292C12.7037 12.6545 12.9582 12.6525 13.197 12.7235C13.4357 12.7944 13.6478 12.935 13.8061 13.1273L14.7955 14.3286C15.208 14.8286 15.1592 15.5636 14.6849 16.0055C13.3886 17.2136 11.6061 17.4617 10.3661 16.4642C8.84657 15.238 7.56529 13.7429 6.58612 12.0536C5.59975 10.3648 4.94054 8.50591 4.64299 6.57296Z"
                              fill="#808C9D"
                            />
                          </svg>
                          Contact No.:
                        </span>
                        <span className="ct_fs_16 ct_fw_600 ct_text_para">
                          {technicianData?.phone_no || "-"}
                        </span>
                      </div>

                      <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center">
                        <span className="mb-0 ct_fs_16 ct_fw_400 ct_text_para d-flex align-items-center">
                          <i className="fa-solid fa-briefcase ct_text_para me-1"></i>
                          Role:
                        </span>
                        <span className="ct_fs_16 ct_fw_600 ct_text_para">
                          {technicianData?.role?.length
                            ? technicianData.role
                              .map((obj) => obj.name)
                              .join(", ") || "-"
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 mb-4">
                  <div className="ct_white_bg ct_dash_card active align-items-center">
                    <div className="d-grid gap-4">
                      <div className="d-flex align-items-center gap-3 justify-content-between">
                        <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
                          Total Tasks
                        </h6>
                        <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
                          {technicianData?.summary?.total_tasks || 0}
                        </h6>
                      </div>
                      <div className="d-flex align-items-center gap-3 justify-content-between">
                        <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
                          Completion Rate
                        </h6>
                        <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
                          {technicianData?.summary?.completion_rate || 0}%
                        </h6>
                      </div>
                      <div className="d-flex align-items-center gap-3 justify-content-between">
                        <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
                          Hourly Rate
                        </h6>
                        <h6 className="ct_ff_ProximaNova_bold ct_fs_18 mb-0">
                          {curSym}
                          {technicianData?.hourly_rate || 0}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-sm-6 mb-4">
                  <div className="ct_white_bg ct_dash_card active">
                    <div className="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p className="mb-0">Total Jobs</p>
                        <h3 className="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                          {technicianData?.summary?.total_tasks || 0}
                        </h3>
                      </div>
                      <div className="ct_dash_icon">
                        <svg
                          width={30}
                          height={30}
                          viewBox="0 0 30 30"
                          fill="none"
                        >
                          <path
                            d="M13.7588 26.25H12.0063C7.525 26.25 5.285 26.25 3.8925 24.8313C2.5 23.4125 2.5 21.1288 2.5 16.5625C2.5 11.9963 2.5 9.7125 3.8925 8.29375C5.285 6.875 7.525 6.875 12.0063 6.875H16.76C21.2413 6.875 23.4825 6.875 24.875 8.29375C25.9463 9.385 26.1925 10.9888 26.25 13.75"
                            stroke="white"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                          />
                          <path
                            d="M20 6.875L19.875 6.4875C19.2563 4.5625 18.9475 3.6 18.2113 3.05C17.4738 2.5 16.4963 2.5 14.5375 2.5H14.2088C12.2525 2.5 11.2738 2.5 10.5375 3.05C9.8 3.6 9.49125 4.5625 8.8725 6.4875L8.75 6.875M21.3888 16.5688C21.62 16.3563 21.735 16.25 21.875 16.25C22.015 16.25 22.13 16.3563 22.3613 16.5688L23.2525 17.39C23.36 17.4887 23.4138 17.5388 23.48 17.5625C23.5475 17.5875 23.62 17.585 23.7675 17.5787L24.97 17.5312C25.28 17.5187 25.435 17.5137 25.5413 17.6025C25.6475 17.6912 25.6688 17.845 25.71 18.1525L25.875 19.385C25.895 19.5275 25.9038 19.5975 25.9388 19.66C25.9738 19.72 26.03 19.7637 26.1425 19.8525L27.1125 20.615C27.3525 20.805 27.4725 20.8987 27.4963 21.0337C27.52 21.1687 27.4388 21.2987 27.2788 21.5587L26.6213 22.6175C26.5463 22.7387 26.5088 22.8 26.4963 22.8675C26.4838 22.935 26.4988 23.0063 26.5288 23.1463L26.79 24.3688C26.8525 24.6688 26.885 24.8188 26.8163 24.9388C26.7475 25.0588 26.6013 25.1062 26.31 25.2012L25.1525 25.5775C25.015 25.6225 24.945 25.645 24.8913 25.69C24.8375 25.7363 24.8038 25.8012 24.7375 25.93L24.1725 27.0187C24.0288 27.2975 23.9563 27.4362 23.825 27.4837C23.6938 27.5312 23.55 27.4713 23.26 27.3513L22.15 26.8913C22.0138 26.835 21.9463 26.8062 21.875 26.8062C21.8038 26.8062 21.7363 26.835 21.6 26.8913L20.49 27.3513C20.2 27.4713 20.0563 27.5312 19.925 27.4837C19.7938 27.4362 19.7213 27.2962 19.5775 27.0187L19.0125 25.93C18.945 25.8012 18.9125 25.7362 18.8588 25.6912C18.805 25.6462 18.735 25.6225 18.5975 25.5787L17.44 25.2012C17.1488 25.1062 17.0025 25.0588 16.9338 24.9388C16.865 24.8188 16.8963 24.67 16.96 24.3688L17.2225 23.1463C17.2513 23.0063 17.2663 22.9363 17.2538 22.8688C17.2281 22.7783 17.1857 22.6935 17.1288 22.6187L16.4725 21.5587C16.31 21.2987 16.23 21.1687 16.2538 21.0337C16.2775 20.8987 16.3975 20.805 16.6375 20.6163L17.6075 19.8538C17.72 19.7638 17.7763 19.72 17.8113 19.6588C17.8463 19.5975 17.855 19.5275 17.8738 19.3837L18.04 18.1525C18.0813 17.8463 18.1025 17.6912 18.2088 17.6025C18.315 17.5137 18.47 17.5187 18.78 17.5312L19.9838 17.5787C20.13 17.585 20.2025 17.5875 20.27 17.5625C20.3363 17.5375 20.39 17.4887 20.4975 17.39L21.3888 16.5688Z"
                            stroke="white"
                            strokeWidth="1.8"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-sm-6 mb-4">
                  <div className="ct_white_bg ct_dash_card">
                    <div className="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p className="mb-0">In Progress Jobs</p>
                        <h3 className="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                          {technicianData?.summary?.in_progress_tasks || 0}
                        </h3>
                      </div>
                      <div className="ct_dash_icon">
                        <svg
                          width={36}
                          height={36}
                          viewBox="0 0 36 36"
                          fill="none"
                        >
                          <path
                            d="M19.5 16.5L27 9"
                            stroke="#23C0E8"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M28.4999 10.5003L25.4999 7.50031L29.2499 5.25031L30.7499 6.75031L28.4999 10.5003ZM6.03739 13.4628C5.31722 12.7433 4.82178 11.8299 4.61139 10.8339C4.401 9.83783 4.48473 8.80211 4.85238 7.85281L6.98539 9.98581H9.98539V6.98581L7.85239 4.85281C8.80176 4.48432 9.8378 4.3999 10.8343 4.60983C11.8308 4.81977 12.7447 5.31499 13.4648 6.03517C14.1848 6.75535 14.6798 7.66939 14.8895 8.66594C15.0992 9.66249 15.0146 10.6985 14.6459 11.6478L24.3509 21.3543C25.3002 20.9856 26.3362 20.901 27.3328 21.1107C28.3293 21.3204 29.2433 21.8154 29.9635 22.5354C30.6837 23.2555 31.1789 24.1694 31.3889 25.1659C31.5988 26.1624 31.5144 27.1984 31.1459 28.1478L29.0144 26.0148H26.0144V29.0148L28.1474 31.1478C27.1983 31.5163 26.1625 31.6008 25.1661 31.3912C24.1698 31.1815 23.2559 30.6866 22.5358 29.9668C21.8157 29.247 21.3205 28.3334 21.1104 27.3372C20.9002 26.3409 20.9843 25.3051 21.3524 24.3558L11.6444 14.6478C10.6955 15.0148 9.66036 15.0982 8.66493 14.8878C7.6695 14.6775 6.75665 14.1824 6.03739 13.4628Z"
                            stroke="#23C0E8"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M18.304 21.7498L9.89799 30.1558C9.7099 30.3443 9.4865 30.4938 9.24056 30.5958C8.99463 30.6978 8.73099 30.7503 8.46474 30.7503C8.19849 30.7503 7.93486 30.6978 7.68892 30.5958C7.44299 30.4938 7.21958 30.3443 7.03149 30.1558L5.84349 28.9678C5.65505 28.7797 5.50554 28.5563 5.40354 28.3104C5.30153 28.0644 5.24902 27.8008 5.24902 27.5346C5.24902 27.2683 5.30153 27.0047 5.40354 26.7587C5.50554 26.5128 5.65505 26.2894 5.84349 26.1013L14.2495 17.6953"
                            stroke="#23C0E8"
                            strokeWidth="1.5"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-xl-4 col-lg-4 col-sm-6 mb-4">
                  <div className="ct_white_bg ct_dash_card">
                    <div className="d-flex align-items-center gap-3 justify-content-between">
                      <div>
                        <p className="mb-0">Completed Jobs</p>
                        <h3 className="ct_fw_700 ct_fs_28 ct_ff_ProximaNova_bold mb-0 ct_black_text">
                          {technicianData?.summary?.completed_tasks || 0}
                        </h3>
                      </div>
                      <div className="ct_dash_icon">
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_1233_4921)">
                            <path d="M26.209 10.459L27.791 12.041L14.625 25.207L8.20898 18.791L9.79102 17.209L14.625 22.043L26.209 10.459ZM18 0C19.6523 0 21.2461 0.210938 22.7812 0.632812C24.3164 1.05469 25.752 1.6582 27.0879 2.44336C28.4238 3.22852 29.6367 4.16602 30.7266 5.25586C31.8164 6.3457 32.7539 7.56445 33.5391 8.91211C34.3242 10.2598 34.9277 11.6953 35.3496 13.2188C35.7715 14.7422 35.9883 16.3359 36 18C36 19.6523 35.7891 21.2461 35.3672 22.7812C34.9453 24.3164 34.3418 25.752 33.5566 27.0879C32.7715 28.4238 31.834 29.6367 30.7441 30.7266C29.6543 31.8164 28.4355 32.7539 27.0879 33.5391C25.7402 34.3242 24.3047 34.9277 22.7812 35.3496C21.2578 35.7715 19.6641 35.9883 18 36C16.3477 36 14.7539 35.7891 13.2188 35.3672C11.6836 34.9453 10.248 34.3418 8.91211 33.5566C7.57617 32.7715 6.36328 31.834 5.27344 30.7441C4.18359 29.6543 3.24609 28.4355 2.46094 27.0879C1.67578 25.7402 1.07227 24.3105 0.650391 22.7988C0.228516 21.2871 0.0117188 19.6875 0 18C0 16.3477 0.210938 14.7539 0.632812 13.2188C1.05469 11.6836 1.6582 10.248 2.44336 8.91211C3.22852 7.57617 4.16602 6.36328 5.25586 5.27344C6.3457 4.18359 7.56445 3.24609 8.91211 2.46094C10.2598 1.67578 11.6895 1.07227 13.2012 0.650391C14.7129 0.228516 16.3125 0.0117188 18 0ZM18 33.75C19.4414 33.75 20.8301 33.5625 22.166 33.1875C23.502 32.8125 24.7559 32.2852 25.9277 31.6055C27.0996 30.9258 28.166 30.0996 29.127 29.127C30.0879 28.1543 30.9082 27.0938 31.5879 25.9453C32.2676 24.7969 32.8008 23.543 33.1875 22.1836C33.5742 20.8242 33.7617 19.4297 33.75 18C33.75 16.5586 33.5625 15.1699 33.1875 13.834C32.8125 12.498 32.2852 11.2441 31.6055 10.0723C30.9258 8.90039 30.0996 7.83398 29.127 6.87305C28.1543 5.91211 27.0938 5.0918 25.9453 4.41211C24.7969 3.73242 23.543 3.19922 22.1836 2.8125C20.8242 2.42578 19.4297 2.23828 18 2.25C16.5586 2.25 15.1699 2.4375 13.834 2.8125C12.498 3.1875 11.2441 3.71484 10.0723 4.39453C8.90039 5.07422 7.83398 5.90039 6.87305 6.87305C5.91211 7.8457 5.0918 8.90625 4.41211 10.0547C3.73242 11.2031 3.19922 12.457 2.8125 13.8164C2.42578 15.1758 2.23828 16.5703 2.25 18C2.25 19.4414 2.4375 20.8301 2.8125 22.166C3.1875 23.502 3.71484 24.7559 4.39453 25.9277C5.07422 27.0996 5.90039 28.166 6.87305 29.127C7.8457 30.0879 8.90625 30.9082 10.0547 31.5879C11.2031 32.2676 12.457 32.8008 13.8164 33.1875C15.1758 33.5742 16.5703 33.7617 18 33.75Z" fill="#23C0E8" />
                          </g>
                          <defs>
                            <clipPath id="clip0_1233_4921">
                              <rect width="36" height="36" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ct_mt_25">
                <ul className="nav nav-tabs dashboard-tabs mb-0" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "jobHistory" ? "active" : ""}`}
                      onClick={() => setActiveTab("jobHistory")}
                      type="button"
                      role="tab"
                    >
                      Job History
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${activeTab === "activity" ? "active" : ""}`}
                      onClick={() => setActiveTab("activity")}
                      type="button"
                      role="tab"
                    >
                      Technician Activity
                    </button>
                  </li>
                </ul>
                {activeTab === "jobHistory" && (
                  <div className="mt-3">
                    <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
                      <h3 className="ct_fs_22 ct_fw_600 mb-0 ct_ff_ProximaNova_semibold">
                        Job History
                      </h3>
                      <div className="ct_min_w_220">
                        <CustomDropdown
                          options={technicianStatusOptions}
                          selectedValue={status}
                          onChange={(value) => setStatus(value)}
                          placeholder="Select Status"
                        />
                      </div>
                    </div>
                    <div className="ct_white_bg p-4 ct_border_radius_12">
                      <div className="custom_table_wrapper mt-3">
                        <div className="table-responsive ct_custom_table">
                          <table className="table">
                            <thead>
                              <tr>
                                <th>S.NO</th>
                                <th>JOB NAME</th>
                                <th>BOAT REG.</th>
                                <th>DATE SCHEDULED</th>
                                <th>STATUS</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {displayUsers?.length !== 0 ? (
                                displayUsers?.map((item, i) => (
                                  <tr key={i}>
                                    <td className="ct_text_para">
                                      {currentPage * usersPerPage + i + 1}
                                    </td>
                                    <td className="ct_text_para">
                                      <div className="ct_overlay_text">
                                        {item?.job_name || "-"}
                                      </div>
                                    </td>
                                    <td className="ct_text_para">
                                      {item?.boat_rego || "-"}
                                    </td>
                                    <td className="ct_text_para">
                                      {pipViewDate(item?.date_scheduled_from) ||
                                        "-"}{" "}
                                      -{" "}
                                      {pipViewDate(item?.date_scheduled_to) ||
                                        "-"}
                                    </td>
                                    <StatusCol
                                      status={item?.status}
                                      type={"jobHis"}
                                    />
                                    <td>
                                      <a
                                        href="javascript:void(0)"
                                        onClick={() => {
                                          const jobRowId =
                                            item?.taskId ||
                                            item?.task_id ||
                                            item?.id ||
                                            item?.jobId;
                                          if (!jobRowId) return;
                                          navigate(pageRoutes.JobDetail, {
                                            state: {
                                              data: {
                                                ...item,
                                                taskId: jobRowId,
                                              },
                                            },
                                          });
                                        }}
                                      >
                                        <svg
                                          width="22"
                                          height="15"
                                          viewBox="0 0 22 15"
                                          fill="none"
                                        >
                                          <path
                                            d="M10.8787 0.789062C17.7816 0.789062 20.9684 7.16109 20.9684 7.16109C20.9684 7.16109 17.7816 13.5331 10.8787 13.5331C3.97585 13.5331 0.789062 7.16109 0.789062 7.16109C0.789062 7.16109 3.97585 0.789062 10.8787 0.789062Z"
                                            stroke="#23C0E8"
                                            strokeWidth="1.57885"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M13.8901 7.16109C13.8994 7.57452 13.8259 7.98563 13.6741 8.37028C13.5223 8.75494 13.2951 9.10539 13.006 9.40105C12.7169 9.69671 12.3716 9.93163 11.9905 10.092C11.6093 10.2524 11.1999 10.335 10.7864 10.335C10.3729 10.335 9.96349 10.2524 9.58233 10.092C9.20116 9.93163 8.85588 9.69671 8.56676 9.40105C8.27763 9.10539 8.05049 8.75494 7.89867 8.37028C7.74685 7.98563 7.6734 7.57452 7.68265 7.16109C7.68265 6.33772 8.00973 5.54807 8.59194 4.96586C9.17415 4.38365 9.9638 4.05657 10.7872 4.05657C11.6105 4.05657 12.4002 4.38365 12.9824 4.96586C13.5646 5.54807 13.8917 6.33772 13.8917 7.16109H13.8901Z"
                                            stroke="#23C0E8"
                                            strokeWidth="1.57885"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </a>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={6}>
                                    <h3 className="mt-3 mb-0 ct_fs_18 text-center">
                                      No job history found
                                    </h3>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="mt-3">
                      {filteredJobHistory?.length > 0 && (
                        <div className="d-flex align-items-center flex-wrap justify-content-between gap-3 mb-3">
                          <PaginationDropdown
                            onChange={(val) => {
                              setUserPerPages(Number(val));
                              setCurrentPage(0);
                            }}
                          />
                          <ReactPagination
                            pageCount={Math.ceil(
                              filteredJobHistory?.length / usersPerPage,
                            )}
                            onPageChange={handlePageClick}
                            currentPage={currentPage}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {activeTab === "activity" && (
                  <div className="mt-3">
                    <TechnicianActivityTab
                      activity={technicianData?.technician_activity}
                      summary={technicianData?.summary}
                      boatsWorkedOn={technicianData?.boats_worked_on}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteModal
        modalId="technician_status_modal"
        heading={statusModalHeading}
        value={statusModalText}
        confirmText={statusButtonText}
        handleDelete={handleStatusToggle}
      />
    </div>
  );
};

export default TechnicianDetail;
